import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import CampaignDashboard from './CampaignDashboard';
import MobileDashboard from './MobileDashboard';
import MobileCampaignDashboard from './MobileCampaignDashboard';
import Feed from './Feed/Feed';
import MobileFeed from './Feed/MobileFeed';
import NavigationBar from './NavigationBar';
import MobileNavigationBar from './MobileNavigationBar';
import MobileBottomHeader from './MobileBottomHeader';
import NavBar from '../brands/NavigationBar';
import ProfileSetup from './profile-setup/Index';
import Settings from './settings/Settings';
import MobileSettings from './settings/MobileSettings';
import Personal from './settings/MobilePersonal';
import Security from './settings/MobileSecurity';
import Social from './settings/MobileSocial';
import AboutMe from './settings/MobileAboutMe';
import ComingSoon from '../ux/ComingSoon';
import InvoiceList from './invoices/InvoiceList';
import Payout from './settings/Payout';
import AudiencePanel, { ReconnectBanner } from './insights/AudiencePanel';
import './influencerTheme.css';

class InfluencerRouter extends React.Component {
  render() {
    const isBrand = JSON.parse(localStorage.getItem('user')).user_type === 'brand';
    return (
      <div className={isBrand ? '' : 'influencer-flow-root'}>
        <Grid container>
          {JSON.parse(localStorage.getItem('user')).user_type !== 'brand' ? (
            <Grid item md={12}>
              {window.matchMedia('(min-width: 768px)').matches ? (
                <NavigationBar />
              ) : (
                <MobileNavigationBar />
              )}
            </Grid>
          ) : (
            <Grid item md={12}>
              <NavBar />
            </Grid>
          )}
        </Grid>
        <Grid container>
          <Grid item md={12} style={{ width: '100%' }}>
            <div className="iv-root" style={{ padding: '12px 20px 0' }}>
              <ReconnectBanner />
            </div>
            <Route exact path={'/influencer'}>
              <Redirect to={isBrand ? '/planner/discover' : `${this.props.match.path}/campaigns`} />
            </Route>

            <Switch>
              {/* The creator campaign list is creator-only. A brand should never
                  land here (they get their own discovery home) -- bounce them,
                  while still allowing brands into the shared campaign feed route
                  below, which they use to view a creator's post performance. */}
              {isBrand ? (
                <Route exact path={`${this.props.match.path}/campaigns`}>
                  <Redirect to="/planner/discover" />
                </Route>
              ) : window.matchMedia('(min-width: 768px)').matches ? (
                <Route
                  exact
                  path={`${this.props.match.path}/campaigns`}
                  component={CampaignDashboard}
                />
              ) : (
                <Route
                  exact
                  path={`${this.props.match.path}/campaigns`}
                  component={MobileCampaignDashboard}
                />
              )}
              {window.matchMedia('(min-width: 768px)').matches ? (
                <Route
                  path={`${this.props.match.path}/campaigns/:campaignId/feeds/:influencerId`}
                  component={Feed}
                />
              ) : (
                <Route
                  path={`${this.props.match.path}/campaigns/:campaignId/feeds/:influencerId`}
                  component={MobileFeed}
                />
              )}
              <Route path={`${this.props.match.path}/dashboard`} component={MobileDashboard} />
              <Route
                exact
                path={`${this.props.match.path}/profile-setup`}
                component={ProfileSetup}
              />
              {window.matchMedia('(min-width: 768px)').matches ? (
                <Route path={`${this.props.match.path}/settings`} component={Settings} />
              ) : (
                <Route path={`${this.props.match.path}/settings`} component={MobileSettings} />
              )}
              <Route path={`${this.props.match.path}/personal-settings`}>
                <Personal />
              </Route>
              <Route path={`${this.props.match.path}/security-settings`}>
                <Security />
              </Route>
              <Route path={`${this.props.match.path}/social-settings`}>
                <Social />
              </Route>
              <Route path={`${this.props.match.path}/about-me`}>
                <AboutMe />
              </Route>
              {/* Payout details on their own route too, so the invoice form
                  can send a creator straight there on mobile or desktop. */}
              <Route exact path={`${this.props.match.path}/payout-settings`}>
                <div style={{ maxWidth: 880, margin: '0 auto', padding: '28px 16px 80px' }}>
                  <Payout />
                </div>
              </Route>
              <Route exact path={`${this.props.match.path}/invoices`}>
                <InvoiceList />
              </Route>
              <Route exact path={`${this.props.match.path}/audience`}>
                <AudiencePanel />
              </Route>
              {/* The staff invoice desk moved out of the creator app to its
                  own staff-gated route; keep the old link working. */}
              <Route exact path={`${this.props.match.path}/invoices/dashboard`}>
                <Redirect to="/internal/invoices" />
              </Route>
              <Route path={`${this.props.match.path}/comingsoon`}>
                <ComingSoon />
              </Route>
              <Route path={`${this.props.match.path}/past`}>
                <ComingSoon />
              </Route>
            </Switch>
          </Grid>
        </Grid>
        <Grid container>
          {JSON.parse(localStorage.getItem('user')).user_type !== 'brand' ? (
            <Grid item md={12}>
              {window.matchMedia('(min-width: 768px)').matches ? '' : <MobileBottomHeader />}
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </div>
    );
  }
}

export default withRouter(InfluencerRouter);
